exports = module.exports = require("../../../../../../web-ai-translation/node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../web-ai-translation/node_modules/css-loader/index.js??ref--8-oneOf-1-1!../../../../../../web-ai-translation/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../web-ai-translation/node_modules/postcss-loader/src/index.js??ref--8-oneOf-1-2!bootstrap/dist/css/bootstrap.css"), "");

// module
exports.push([module.id, ".promo-name[data-v-b4ec1794]{display:flex;flex-direction:column;gap:4px}.promo-title[data-v-b4ec1794]{font-weight:700;color:#1f2937}.promo-note[data-v-b4ec1794]{font-size:.75rem;color:#8898aa;max-width:180px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
